import { GoogleTagManager } from "@next/third-parties/google";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import "../styles/globals.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import type { AppProps } from "next/app";
import { QueryClient, QueryClientProvider } from "react-query";
import "react-toastify/dist/ReactToastify.css";
import { Loader } from "@itandi/itandi-bb-ui/Loader";
import { NotificationBarStore } from "@itandi/itandi-bb-ui/NotificationBarStore";
import { ToastContainer } from "react-toastify";
import { z } from "zod";
import { Layout } from "../components/Layout";
import { zodCustomErrorMap } from "../hooks/zodCustomErrorMap";
import "dayjs/locale/ja";
import "remixicon/fonts/remixicon.css";

type withoutLayoutPageProps = {
	withoutLayout?: boolean;
};

export const theme = createTheme();
const queryClient = new QueryClient();

z.setErrorMap(zodCustomErrorMap);

function App({ Component, pageProps }: AppProps<withoutLayoutPageProps>) {
	const router = useRouter();

	const withoutLayout = pageProps?.withoutLayout ?? false;

	const [display, setDisplay] = useState(false);
	useEffect(() => {
		if (router.isReady) {
			setDisplay(true);
		}
	}, [router.isReady]);

	if (!display) {
		return <Loader />;
	}

	return (
		<>
			<GoogleTagManager gtmId="GTM-WXJGP3PD" />
			<Head>
				<title>点検管理</title>
				<link href="https://brand-ui.itandi.app/favicons/tk.ico" rel="icon" />
			</Head>
			<ToastContainer
				autoClose={5000}
				closeOnClick
				draggable
				hideProgressBar={false}
				newestOnTop={false}
				pauseOnFocusLoss
				pauseOnHover
				position="top-right"
				rtl={false}
				theme="light"
			/>
			<LocalizationProvider adapterLocale="ja" dateAdapter={AdapterDayjs}>
				<QueryClientProvider client={queryClient}>
					<ThemeProvider theme={theme}>
						{withoutLayout ? (
							<NotificationBarStore>
								<Component {...pageProps} />
							</NotificationBarStore>
						) : (
							<Layout>
								<NotificationBarStore>
									<Component {...pageProps} />
								</NotificationBarStore>
							</Layout>
						)}
					</ThemeProvider>
				</QueryClientProvider>
			</LocalizationProvider>
		</>
	);
}
export default App;
